module.exports = __webpack_public_path__ + "static/img/frametour.e7476f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/frametour.png
// module id = Y5r+
// module chunks = 1